// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: none !important;
  border-color: #078BCB !important;
  border-radius: 0.375rem !important;
  border-width: 3px !important;
}

.btn-outline-secondary:hover, .btn-outline-secondary.hover {
  background: white;
  color: black;
}

li:hover {
  background-color: #f5f5f5;
}

.content-card-wrapper {
  border-radius: 0.5rem;
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
}
.content-card-wrapper.previous-selected {
  border-width: 2px;
  border-color: #d3d3d3;
}
.content-card-wrapper.selected {
  border-width: 2px;
  border-color: #078BCB;
}

.content-card-header {
  padding-bottom: 5px;
}

.dropdown-custom {
  min-width: 200px;
}
.dropdown-custom button {
  border-color: #caced5;
  border-radius: 0;
}

.header-divider {
  border-bottom: 1px solid #078BCB;
  margin-bottom: 10px;
}

.icon-link-text {
  text-decoration-line: underline;
}

.icon-only {
  font-size: 20px;
  color: #76bc21;
  margin-right: 9px;
}

.circle-icon-only {
  position: fixed;
  right: 401px;
  bottom: 1124px;
}

.status-indicator {
  height: 10px;
  width: 10px;
}

.content-card-header.row {
  padding-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/@itc-core/components/components/content-card/content-card.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EACC,2BAAA;EACA,gCAAA;EACA,kCAAA;EACA,4BAAA;AACD;;AAEA;EACC,iBAAA;EACA,YAAA;AACD;;AAEA;EACC,yBDCW;ACAZ;;AAEA;EAEC,qBAAA;EACA,yBDIO;ECHP,aAAA;EACA,6EAAA;AAAD;AAEC;EACC,iBAAA;EACA,qBDcW;ACdb;AAGC;EACC,iBAAA;EACA,qBD9BQ;AC6BV;;AAKA;EACC,mBAAA;AAFD;;AAKA;EACC,gBAAA;AAFD;AAIC;EACC,qBDhCS;ECiCT,gBAAA;AAFF;;AAMA;EACC,gCAAA;EACA,mBAAA;AAHD;;AAMA;EACC,+BAAA;AAHD;;AAMA;EACC,eAAA;EACA,cAAA;EACA,iBAAA;AAHD;;AAMA;EACC,eAAA;EACA,YAAA;EACA,cAAA;AAHD;;AAMA;EACC,YAAA;EACA,WAAA;AAHD;;AAMA;EACC,mBAAA;AAHD","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n\tbox-shadow: none !important;\n\tborder-color: $primary !important;\n\tborder-radius: 0.375rem !important;\n\tborder-width: 3px !important;\n}\n\n.btn-outline-secondary:hover, .btn-outline-secondary.hover {\n\tbackground: white;\n\tcolor: black;\n}\n\nli:hover {\n\tbackground-color: $highlight;\n}\n\n.content-card-wrapper {\n\t//border: $border;\n\tborder-radius: 0.5rem;\n\tbackground-color: $white;\n\tpadding: 1rem;\n\tbox-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n\n\t&.previous-selected {\n\t\tborder-width: 2px;\n\t\tborder-color: $light-gray;\n\t}\n\n\t&.selected {\n\t\tborder-width: 2px;\n\t\tborder-color: $primary;\n\t}\n}\n\n.content-card-header {\n\tpadding-bottom: 5px;\n}\n\n.dropdown-custom {\n\tmin-width: 200px;\n\n\tbutton {\n\t\tborder-color: $disabled;\n\t\tborder-radius: 0;\n\t}\n}\n\n.header-divider {\n\tborder-bottom: 1px solid $primary;\n\tmargin-bottom: 10px;\n}\n\n.icon-link-text {\n\ttext-decoration-line: underline;\n}\n\n.icon-only {\n\tfont-size: 20px;\n\tcolor: #76bc21;\n\tmargin-right: 9px;\n}\n\n.circle-icon-only {\n\tposition: fixed;\n\tright: 401px;\n\tbottom: 1124px;\n}\n\n.status-indicator {\n\theight: 10px;\n\twidth: 10px;\n}\n\n.content-card-header.row {\n\tpadding-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
